import {
  MeetingRoomOutlined,
  ChildCareOutlined,
  FitnessCenterOutlined,
  SpaOutlined,
  HotTubOutlined,
  LocalLibraryOutlined,
  TheatersOutlined,
  MicExternalOnOutlined,
  WbSunnyOutlined,
  GroupWorkOutlined,
  DirectionsRunOutlined,
  SelfImprovementOutlined,
  MosqueOutlined,
  SportsTennisOutlined,
  SportsGolfOutlined,
  ParkOutlined,
  DirectionsWalkOutlined,
  LockOutlined,
  ShowerOutlined,
  FaceRetouchingNaturalOutlined,
  LocalParkingOutlined,
  ElevatorOutlined,
  TvOutlined,
  WifiOutlined,
  SecurityOutlined,
  VpnKeyOutlined,
  VideocamOutlined,
  EmojiPeopleOutlined,
  PowerOutlined,
  SportsSoccerOutlined,
  SportsBasketballOutlined,
  SportsEsportsOutlined,
  SchoolOutlined,
  StorefrontOutlined,
  FaceOutlined,
  Pool,
  Waves,
  LocalFireDepartment,
  SportsVolleyball,
  Sports,
  SportsHandball,
  BusinessCenter,
  Celebration,
} from '@mui/icons-material'

export const facilitiesIconMap: Record<string, React.ComponentType<any>> = {
  // พื้นที่ส่วนกลางและห้องต่างๆ
  'Lobby': MeetingRoomOutlined,
  'ClubHouse': BusinessCenter,
  'Multifunctionroom': GroupWorkOutlined,
  'Library': LocalLibraryOutlined,
  'Theaterroom': TheatersOutlined,
  'Karaokeroom': MicExternalOnOutlined,
  'Skylounge': WbSunnyOutlined,
  'TutorRoom': SchoolOutlined,
  'GameRoom': SportsEsportsOutlined,
  'SnookerRoom': SportsEsportsOutlined,
  'Store': StorefrontOutlined,

  // สระว่ายน้ำและกิจกรรมน้ำ
  'SwimmingPool': Pool,
  'KidPool': ChildCareOutlined,
  'Jacuzzi': HotTubOutlined,
  'Waterfall': Waves,

  // ออกกำลังกายและกีฬา
  'Fitness': FitnessCenterOutlined,
  'AerobicRoom': DirectionsRunOutlined,
  'YogaRoom': SelfImprovementOutlined,
  'JoggingTrack': DirectionsWalkOutlined,
  
  // กีฬาต่างๆ
  'TableTennis': SportsTennisOutlined,
  'TennisCourt': SportsTennisOutlined,
  'BadmintonCourt': SportsVolleyball,
  'SquashCourt': SportsHandball,
  'FutsalField': SportsSoccerOutlined,
  'BasketballCourt': SportsBasketballOutlined,
  'BowlingLanes': Sports,
  'PuttingGreen': SportsGolfOutlined,

  // สปาและผ่อนคลาย
  'Sauna': SpaOutlined,
  'Steam': HotTubOutlined,
  'ShowerRoom': ShowerOutlined,
  'MakeUproom': FaceRetouchingNaturalOutlined,
  'Locker': LockOutlined,

  // พื้นที่เด็กและครอบครัว
  'KidsPlayZone': ChildCareOutlined,
  'Garden': ParkOutlined,
  'Party&BBQarea': Celebration,

  // ห้องศาสนา
  'PrayRoom': MosqueOutlined,

  // ระบบและสิ่งอำนวยความสะดวก
  'No.ofParkingSpace': LocalParkingOutlined,
  'Elevator': ElevatorOutlined,
  'FireSafetySystem': LocalFireDepartment,
  'SatellitTVSystem': TvOutlined,
  'InternetWifi': WifiOutlined,
  'Emergencypowerbackupsystems': PowerOutlined,

  // ระบบรักษาความปลอดภัย
  'Securitysystem': SecurityOutlined,
  'Entrance&ExitAccessKeyCard': VpnKeyOutlined,
  'CCTVsystem': VideocamOutlined,
  'SecurityGuard:24hoursservice': EmojiPeopleOutlined,
  'Entrance&exitFacescanaccess': FaceOutlined,
};